import { MdError } from "react-icons/md";

const DefaultCheckbox = ({ id, label, type, placeholder, required, name, value, labelClass, classnames = "", onChange = () => null, onBlur, error, readOnly = false }) => {
    return (
        <div className={"flex flex-col gap-1 relative"}>
            <div className={`flex flex-col`}>
                <div className="flex flex-row items-center gap-2">
                    <input
                        id={id}
                        type={"checkbox"}
                        placeholder={placeholder ? placeholder : `Enter ${label}`}
                        name={name}
                        checked={value}
                        onChange={(e) => onChange(e.target?.checked)}
                        onBlur={onBlur}
                        value={value}
                        disabled={readOnly}
                        className={`ring-0 focus:ring-0 focus:shadow-none focus:border-gray-200 text-sm rounded-md border border-[#d2d2d2] bg-light ${classnames}
                  ${error ? 'bg-red-100 rounded-md border border-red-200' : ''} ${readOnly ? 'bg-light cursor-not-allowed' : 'cursor-pointer'}`}
                    />
                    {label && <label
                        className={`text-theme font-medium text-sm ${labelClass}`} htmlFor={id}
                    >
                        {label}{required ? <span className={"text-red-600"}>*</span> : ""}
                    </label>}
                </div>
                {error ?
                    <span className="flex items-center gap-1 text-sm text-error-600">
                        <MdError />
                        <p>{error}</p>
                    </span>
                    :
                    ""
                }
            </div>
        </div>
    )
}
export default DefaultCheckbox;
